import React, { useEffect, useState } from "react";
import { getAppParams, getUrlParams } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";

// Coerce common "truthy" API representations (boolean, 1/0, "1"/"0",
// "true"/"false", "yes"/"no", "y"/"n") into a real boolean.
const toBool = (val) => {
  if (typeof val === "boolean") return val;
  if (typeof val === "number") return val === 1;
  if (typeof val === "string") {
    const v = val.trim().toLowerCase();
    return v === "1" || v === "true" || v === "yes" || v === "y";
  }
  return false;
};

// API response shape: { data: { sleep_insight: boolean } } — see
// check_sleep_insight() in lifestylecard.php (true only if the user has a
// tracker imei on file). The endpoint doesn't set a top-level `code` on
// success, only on error, so this reads straight off `data.sleep_insight`.
const extractAvailability = (payload) => toBool(payload?.data?.sleep_insight);

const SleepScore = () => {
  const { encryptedId } = getUrlParams();
  const [trackerAvailable, setTrackerAvailable] = useState(false);

  useEffect(() => {
    if (!encryptedId) return;

    lifestyleApi
      .checkSleepInsight(encryptedId)
      .then((res) => {
        setTrackerAvailable(extractAvailability(res?.data));
      })
      .catch((err) => {
        console.error("checkSleepInsight:", err);
        setTrackerAvailable(false);
      });
  }, [encryptedId]);

  if (!trackerAvailable) return null;

  // The sleep insights page needs the same session params this page was
  // opened with, not just the user id. Empty ones are skipped.
  const handleClick = () => {
    const search = new URLSearchParams(window.location.search);
    const {
      uid,
      goqiiUserId,
      goqiiAccessToken,
      authToken,
      appVersion,
      appType,
      apiKey,
      nonce,
      signature,
    } = getAppParams();
    const { theme, lang } = getUrlParams();
    const encUid = uid || encryptedId || "";

    const params = {
      goqiiUserId: goqiiUserId || encUid,
      uid: encUid,
      uuid: search.get("uuid") || encUid,
      goqiiuserid: goqiiUserId,
      goqiiAccessToken,
      authToken,
      appVersion,
      appType,
      theme,
      loader: search.get("loader"),
      lang,
      apiKey,
      nonce,
      signature,
    };

    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value) qs.set(key, value);
    });

    window.location.href = `https://lifestyleinsights.goqii.com/sleepinsights?${qs.toString()}`;
  };

  return (
    <div
      onClick={handleClick}
      style={{
        width: "100%",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        cursor: "pointer",
      }}
    >
      <img
        src="https://appcdn.goqii.com/storeimg/75943_1786098532.jpg"
        alt="Sleep Score"
        style={{ width: "100%", display: "block" }}
      />
    </div>
  );
};

export default SleepScore;
